import Vue from 'vue';
import utils from "../common/utils";
import RecoveryPassword from "../components/registration/recovery-password";

Vue.use(utils);

new Vue({
    el: '#recovery-password',
    components: {
        RecoveryPassword
    }
});